/**
 * Owner: Masa Bayu
 * File: pdf-types.ts
 * Date:Time: 2026-09-22 17:29
 * Description: PDFAdapter ship flag · sourceType pdf · text resolve contract.
 */

export const QX_PDF_ADAPTER_VERSION = '1.0.0' as const;

export const QX_PDF_FEATURE_FLAG = Object.freeze({
  id: 'qx.import.pdf_adapter' as const,
  adapterShipped: true as const,
  adapterGate: 'PDF-BUILD-AUTH' as const,
  irGate: 'QX-DOC-04' as const,
  defaultEnabledInProduction: false as const,
  doc03Undisturbed: true as const,
});

export const QX_PDF_SOURCE_TYPE = 'pdf' as const;

/**
 * Secure-intake stub: maps sourceRef → UTF-8 extracted text.
 * Real QX-DOC-03 workers replace this; PDF bytes never stored on IR/job rows.
 * Layout ≠ semantic authority — text path only for this ship.
 */
export type QXPdfTextResolve = (sourceRef: string) => string | null;
